// extracted by css-extract-rspack-plugin
export default {"settlementQuotaConfig":"settlementQuotaConfig-KNY4Ku","rightTable":"rightTable-eJA4uA","rightTableTop":"rightTableTop-rISotf"};